const Footer = () => {
    return (
      <footer className="footer-area">
        <div className="footer-top pt-100 pb-70">
          <div className="container pt-5">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="footer-widget">
                  <div className="navbar-brand">
                    <a href="index.html">
                      <img
                        className="w-50"
                        src={process.env.PUBLIC_URL + "/assets/img/logo.png"}
                        alt="Logo"
                      />
                    </a>
                  </div>
                  <p className="mt-1">
                    ARES fabrica equipos de dosificación y medición con la última tecnología y con más de 40 años de experiencia. Pionera en bombas
                    compactas inteligentes con datalogging, la empresa atiende los sectores alimenticio, farmacéutico, químico y de tratamiento de aguas con una relación cercana con sus clientes
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                <div className="footer-widget">
                  <h3>Productos</h3>
                  <ul className="footer-links">
                    <li>
                      <i className="bx bx-chevrons-right" />
                      <a href="/productos/bombas-dosificadoras">Bombas</a>
                    </li>
                    <li>
                      <i className="bx bx-chevrons-right" />
                      <a href="/productos/controladores-y-medidores">
                        Controladores y medidores
                      </a>
                    </li>
                    <li>
                      <i className="bx bx-chevrons-right" />
                      <a href="/productos/accesorios">Accesorios</a>
                    </li>
                    <li>
                      <i className="bx bx-chevrons-right" />
                      <a href="/productos/sensores">Sensores</a>
                    </li>
                    <li>
                      <i className="bx bx-chevrons-right" />
                      <a href="/productos/equipos-especiales">
                        Equipos especiales
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                <div className="footer-widget">
                  <h3>Aplicaciones</h3>
                  <ul className="footer-links">
                    <li>
                      <i className="bx bx-chevrons-right" />
                      <a href="/aplicaciones/tratamiento-de-aguas">
                        Tratamiento de Aguas
                      </a>
                    </li>
                    <li>
                      <i className="bx bx-chevrons-right" />
                      <a href="/aplicaciones/agroindustria">Agroindustria</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 col-sm-6 col-12">
                <div className="footer-widget">
                  <h3>Enlaces</h3>
                  <ul className="footer-links">
                    <li>
                      <i className="bx bx-chevrons-right" />
                      <a href="/productos">Productos</a>
                    </li>
                    <li>
                      <i className="bx bx-chevrons-right" />
                      <a href="/servicios">Servicios</a>
                    </li>
                    <li>
                      <i className="bx bx-chevrons-right" />
                      <a href="/descargas">Descargas</a>
                    </li>
                    <li>
                      <i className="bx bx-chevrons-right" />
                      <a href="/nosotros">Nosotros</a>
                    </li>
                    <li>
                      <i className="bx bx-chevrons-right" />
                      <a href="/contacto">Contacto</a>
                    </li>
                    <li>
                      <i className="bx bx-chevrons-right" />
                      <a href="/garantia.html">Garantía</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="bg-image" />
          </div>
        </div>
        <div className="copy-right-area">
          <div className="container">
            <div className="copy-right-content">
              <ul className="info-list">
                <li className="content">
                  <i className="bx bx-map" />
                  <a href="https://www.google.com/maps/place/Ares+Electr%C3%B3nica+Industrial+S.A./@-34.544611,-58.506399,19z/data=!4m6!3m5!1s0x95bcb6d839cdb513:0x13426d56a9c0734c!8m2!3d-34.5446107!4d-58.5063986!16s%2Fg%2F1tcv2msr?hl=es-419&entry=ttu&g_ep=EgoyMDI0MDkxNi4wIKXMDSoASAFQAw%3D%3D">
                    Gral. Las Heras 3784 (B1603) Villa Martelli - Buenos Aires - Argentina
                  </a>
                </li>
                <li className="content">
                  <i className="bx bx-envelope" />
                  <a href="mailto: ares@ares.com.ar"> ares@ares.com.ar</a>
                </li>
              </ul>
              <span>
                Copyright © <a href="/nosotros">Ares Electrónica</a>
              </span>
            </div>
          </div>
        </div>
      </footer>
    );
  };
  export default Footer;